import React from "react";
import { useSiteMetadata } from "../hooks/use-site-metadata";
import { Script } from "gatsby";

const isBrowser = typeof window !== "undefined";

export const Seo = ({ title, description, pathname, index, children }) => {
  const {
    title: defaultTitle,
    description: defaultDescription,
    image,
    siteUrl,
    // twitterUsername,
  } = useSiteMetadata();

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    image: `${siteUrl}${image}`,
    url: `${siteUrl}${pathname || ``}`,

    index: index,
    // twitterUsername,
  };

  return (
    <>
      <html lang="en" />
      {/* <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${process.env.GTAG}`}
      />
      <Script>
        {`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config','${process.env.GTAG}', { page_path: location ? location.pathname + location.search + location.hash : undefined });
  `}
      </Script> */}
      <Script id="gtag-config">
        {`
        ${isBrowser} &&
          (function(w,d,s,l,i){
            w[l]=w[l]||[];
            w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
            var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),
              dl=l!='dataLayer'?'&l='+l:'';
              j.async=true;j.src = 'https://www.googletagmanager.com/gtm.js?id='+i+dl;
              f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-PSC59SKH')
       `}
      </Script>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="image" content="/favicon.png" />
      <meta name="author" content="Mabrosi inc. | D8ship team" />
      <meta
        name="copyright"
        content="&copy; 2024 Mabrosi inc. All Rights Reserved."
      />
      <meta name="robots" content={seo.index} />
      <meta name="rating" content="general" />
      {/* <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} /> */}
      {/* <meta name="twitter:creator" content={seo.twitterUsername} /> */}
      {/*
<!-- Open Graph / Facebook -->
<meta property="og:type" content="website">
<meta property="og:url" content="https://github.com">
<meta property="og:title" content="GitHub: Let’s build from here · GitHub">
<meta property="og:description" content="GitHub is where over 100 million developers shape the future of software, together. Contribute to the open source community, manage your Git repositories, review code like a pro, track bugs and features, power your CI/CD and DevOps workflows, and secure code before you commit it.">
<meta property="og:image" content="https://github.githubassets.com/assets/campaign-social-031d6161fa10.png">

<!-- Twitter -->
<meta property="twitter:card" content="summary_large_image">
<meta property="twitter:url" content="https://github.com">
<meta property="twitter:title" content="GitHub: Let’s build from here · GitHub">
<meta property="twitter:description" content="GitHub is where over 100 million developers shape the future of software, together. Contribute to the open source community, manage your Git repositories, review code like a pro, track bugs and features, power your CI/CD and DevOps workflows, and secure code before you commit it.">
<meta property="twitter:image" content="https://github.githubassets.com/assets/campaign-social-031d6161fa10.png"></meta> */}
      <meta name="application-name" content="D8ship" />
      <meta httpEquiv="content-type" content="text/html;charset=utf-8" />
      <meta httpEquiv="content-language" content="en" />
      <meta httpEquiv="content-language" content="en-gb" />
      {/* <link rel="shortcut icon" sizes="any" href="/favicon.ico" /> */}
      {/* <link rel="icon" href="/favicon.ico" size="any" /> */}

      {/* <link rel="icon" type="image/x-icon" href="/favicon.ico" /> */}
      {/* <link rel="apple-touch-icon" href="/apple-touch-icon.png" /> */}
      {/* <link rel="apple-touch-startup-image" href="/apple-touch-icon.png" /> */}
      {/* <link rel="apple-touch-icon-precomposed" href="/apple-touch-icon.png" /> */}
      {/* <link rel="apple-touch-icon" sizes="57x57" href="/apple-icon-57x57.png" /> */}
      {/* <link rel="apple-touch-icon" sizes="60x60" href="/apple-icon-60x60.png" /> */}
      {/* <link rel="apple-touch-icon" sizes="72x72" href="/apple-icon-72x72.png" />
      <link rel="apple-touch-icon" sizes="76x76" href="/apple-icon-76x76.png" />
      <link
        rel="apple-touch-icon"
        sizes="114x114"
        href="/apple-icon-114x114.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="120x120"
        href="/apple-icon-120x120.png"
      />

      <link
        rel="apple-touch-icon"
        sizes="152x152"
        href="/apple-icon-152x152.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href="/apple-icon-180x180.png"
      />
      <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#00ffff" />
      <link
        rel="apple-touch-icon-precomposed"
        sizes="57x57"
        href="apple-touch-icon-57x57.png"
      />
      <link
        rel="apple-touch-icon-precomposed"
        sizes="114x114"
        href="apple-touch-icon-114x114.png"
      />
      <link
        rel="apple-touch-icon-precomposed"
        sizes="72x72"
        href="apple-touch-icon-72x72.png"
      />
      <link
        rel="apple-touch-icon-precomposed"
        sizes="144x144"
        href="apple-touch-icon-144x144.png"
      />
      <link
        rel="apple-touch-icon-precomposed"
        sizes="60x60"
        href="apple-touch-icon-60x60.png"
      />
      <link
        rel="apple-touch-icon-precomposed"
        sizes="120x120"
        href="apple-touch-icon-120x120.png"
      />
      <link
        rel="apple-touch-icon-precomposed"
        sizes="76x76"
        href="apple-touch-icon-76x76.png"
      />
      <link
        rel="apple-touch-icon-precomposed"
        sizes="152x152"
        href="apple-touch-icon-152x152.png"
      /> */}
      <meta property="og:url" content="https://d8ship.com/" />
      <meta property="og:locale" content="en_CA" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="D8ship (Canada)" />
      <meta property="og:image" content="https://d8ship.com/favicon.png" />
      {/* <meta name="apple-mobile-web-app-capable" content="yes" /> */}
      {/* <meta name="apple-mobile-web-app-status-bar-style" content="black" /> */}
      {/* <link
        rel="icon"
        href="https://mabrosi.com/favicon.ico"
        type="image/x-icon"
      />
      <link
        rel="shortcut icon"
        href="https://mabrosi.com/favicon.ico"
        type="image/x-icon"
      /> */}
      <meta name="viewport" content="width = device-width" />
      <meta name="viewport" content="initial-scale = 1.0" />

      {/* <meta name="theme-color" content="#ffffff" /> */}

      {/* <link rel="icon" type="image/png" href="/favicon.png" /> */}
      {/* <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href="/favicon-16x16.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href="/favicon-32x32.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="96x96"
        href="/favicon-96x96.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="192x192"
        href="/android-icon-192x192.png"
      /> */}

      {/* <meta name="msapplication-TileColor" content="#000000" />
      <meta name="msapplication-TileImage" content="/ms-icon-144x144.png" />
      <meta name="msapplication-square70x70logo" content="mstile-70x70.png" />
      <meta
        name="msapplication-square150x150logo"
        content="mstile-150x150.png"
      />
      <meta name="msapplication-wide310x150logo" content="mstile-310x150.png" />
      <meta
        name="msapplication-square310x310logo"
        content="mstile-310x310.png"
      /> */}
      {children}
    </>
  );
};
